<template>
    <div>
        <div>
            <a ref="link" :style="{ display: 'none' }" />
            <v-row class="d-flex">
                <v-col cols="2" class='d-flex align-center justify-center pb-0'>
                    <v-menu v-model="menuOpen" offset-y :close-on-content-click="false" content-class="columnMenu">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text small class="manage-btn btn" v-bind="attrs" v-on="on">
                                {{ $t("Manage Columns") }}
                                <v-icon right :class="{ rotate: menuOpen }">
                                    mdi-chevron-down
                                </v-icon>
                            </v-btn>
                        </template>
                        <v-card class="column-card">
                            <v-card-title class="column-header">
                                {{ $t("Select Columns") }}
                            </v-card-title>
                            <v-divider />
                            <v-list dense class="select-all">
                                <v-list-item>
                                    <v-checkbox :input-value="isAllSelected" @change="toggleSelectAll" hide-details />
                                    <v-list-item-title>
                                        {{ $t("Select All") }}
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                            <v-divider />
                            <v-card-text class="column-list">
                                <v-list dense>
                                    <v-list-item v-for="header in shelfHeaders.slice(2)" :key="header.value">
                                        <v-checkbox v-model="visibleColumns" :value="header.text" hide-details />
                                        <v-list-item-title class="column-text">
                                            {{ header.text }}
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-card-text>
                            <v-divider />
                            <v-card-actions class="column-footer">
                                <v-btn color="error" style="background: #c57171;color: #ffffff !important;width:80px"
                                    text small @click="menuOpen = false" class='mr-4'>
                                    {{ $t("Cancel") }}
                                </v-btn>
                                <v-spacer />
                                <v-btn color="primary" small style="width:80px" @click="handleColumnSave">
                                    {{ $t("Save") }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>
                </v-col>
                <v-col cols="1" class="d-flex align-center justify-center">
                    <v-divider vertical></v-divider>
                </v-col>
                <v-col cols="9">
                    <section class="searchArea">
                        <v-select v-model="searchBy.floor" :items="floorItems" :label="$t('Floor')"
                            :placeholder="$t('Select Floor')" class="form-select ml-3" style="width: 20%;" clearable
                            outlined dense persistent-hint hide-details></v-select>
                        <v-select v-model="searchBy.section" :items="floorMap[searchBy.floor]" :disabled="!searchBy.floor" :label="$t('Section')"
                            :placeholder="$t('Select Section')" class="form-select ml-3" style="width: 20%;" clearable
                            outlined dense persistent-hint hide-details></v-select>
                        <v-text-field v-model="searchBy.shelfId" :label="$t('Shelf Id')"
                            :placeholder="$t('Input Shelf Id')" class="form-input ml-3" style="width: 20%;" outlined
                            dense hide-details clearable></v-text-field>
                        <v-btn @click="handleSearch" class="btn type-search ml-10" text style="width:120px;">
                            {{ $t("Search") }}
                        </v-btn>
                    </section>
                    <section class="searchArea">
                        <v-select v-model="searchBy.type" :items="typeItems" :label="$t('Type')"
                            :placeholder="$t('Select Type')" class="form-select ml-3" style="width: 20%;" clearable
                            outlined dense persistent-hint hide-details></v-select>
                        <v-menu v-model="showStartDatePicker" :close-on-content-click="false"
                            transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field :value="searchBy.startDate"
                                    @click:clear="clearDate(searchBy, 'startDate')" :label="`${$t('Period')}`"
                                    :placeholder="`${$t('Select start date')}`" class="form-input ml-3"
                                    style="width: 20%;" v-bind="attrs" v-on="on" outlined dense hide-details readonly
                                    clearable>
                                    <template v-slot:append>
                                        <img width="16" height="16" src="@/assets/img/ico-calendar.png" />
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker v-model="searchBy.startDate" @change="checkStartDate"
                                :locale="languageCodes[$store.getters['dataStore/GET_CURRENT_LANGUAGE']]"
                                @input="showStartDatePicker = false" no-title></v-date-picker>
                        </v-menu>
                        <span class="ml-1 mr-1">~</span>
                        <v-menu v-model="showEndDatePicker" :close-on-content-click="false"
                            transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field :value="searchBy.endDate" @click:clear="clearDate(searchBy, 'endDate')"
                                    v-bind="attrs" v-on="on" :placeholder="`${$t('Select end date')}`"
                                    class="form-input" style="width: 20%;" outlined dense hide-details solo readonly
                                    clearable>
                                    <template v-slot:append>
                                        <img width="16" height="16" src="@/assets/img/ico-calendar.png" />
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker v-model="searchBy.endDate"
                                :locale="languageCodes[$store.getters['dataStore/GET_CURRENT_LANGUAGE']]"
                                @change="checkEndDate" @input="showEndDatePicker = false" no-title></v-date-picker>
                        </v-menu>
                        <v-btn @click="clearSearch" class="btn type-search ml-10" text style="width:120px;">
                            {{ $t("Clear") }}
                        </v-btn>
                    </section>
                </v-col>
            </v-row>
        </div>
        <v-data-table v-model="selected" :headers="filteredHeaders" :items="issueList" :hide-default-footer="true"
            show-select class="tbl-type01 mt-4">
            <template v-slot:item.type="{ item }">
              <div>{{ textPicker(item.type) }}</div>
            </template>
            <template v-slot:item.location="{ item }">
                {{ item.floor }}_{{ item.shelfId }}
            </template>
            <template v-slot:item.status="{ item }">
                <div :style="{ color: item.status.toLowerCase() === 'open' ? 'orange' : item.status.toLowerCase() === 'resolved' ? 'green' : item.status.toLowerCase() === 'pending' ? '#c17f00' : 'gray', fontWeight: 'bold' }">
                    {{ item.status }}
                </div>
            </template>
            <template v-slot:item.duration="{ item }">
                {{ item.createdAt ? convertDate(new Date() - new Date(item.createdAt)) : '' }}
            </template>
            <template v-slot:item.actions="{ item }">
                <template v-if="item.status.toLowerCase() === 'open'">
                  <div class="action-group">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div @click="confirmUpdateStatus(item, 'rejected')" class="actions" v-bind="attrs" v-on="on">
                        <v-icon size="18" style="margin-right: 5px; color: #BE4653;">mdi-close</v-icon>
                      </div>
                    </template>
                    <span>{{ $t("Reject") }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="actions" @click="confirmUpdateStatus(item, 'resolved')" v-bind="attrs" v-on="on">
                        <v-icon size="18" style="margin-right: 5px; color: #1D6E35;">mdi-check</v-icon>
                      </div>
                    </template>
                    <span>{{ $t("Resolve") }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="actions" @click="confirmUpdateStatus(item, 'pending')" v-bind="attrs" v-on="on">
                        <v-icon size="18" style="margin-right: 5px; color: #c17f00;">mdi-clock-outline</v-icon>
                      </div>
                    </template>
                    <span>{{ $t("Pending") }}</span>
                  </v-tooltip>
                  </div>
                </template>

                <template v-else-if="item.status.toLowerCase() === 'pending'">
                   <div class="action-group">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="actions" @click="confirmUpdateStatus(item, 'rejected')" v-bind="attrs" v-on="on">
                        <v-icon size="18" style="margin-right: 5px; color: #BE4653;">mdi-close</v-icon>
                      </div>
                    </template>
                    <span>{{ $t("Reject") }}</span>
                    </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="actions" @click="confirmUpdateStatus(item, 'resolved')" v-bind="attrs" v-on="on">
                        <v-icon size="18" style="margin-right: 5px; color: #1D6E35;">mdi-check</v-icon>
                      </div>
                    </template>
                    <span>{{ $t("Resolve") }}</span>
                </v-tooltip>
                  </div>
                </template>
                <template v-else-if="item.status.toLowerCase() === 'no_issue'">
                  <div class="action-group">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="actions" @click="confirmUpdateStatus(item, 'reOpen')" v-bind="attrs" v-on="on">
                        <v-icon size="18" style="margin-right: 5px; color: #2C8CC4;">mdi-reload</v-icon>
                      </div>
                    </template>
                    <span>{{ $t("Reopen") }}</span>
                  </v-tooltip>
                  </div>
                </template>
            </template>
            <template v-slot:item.createdAt="{ item }">
                {{ item.createdAt ? formatTimeStamp(item.createdAt) : '' }}
            </template>
            <template v-slot:item.detail="{item}">
                <v-icon size="18" @click="handleDetailClick(item)">mdi-image-filter-center-focus-weak</v-icon>
            </template>
        </v-data-table>
        <v-row class="mt-4">
            <v-col cols="12" class="d-flex justify-space-between align-end">
                <div>
                    <v-btn class="btn mr-2" text :disabled="btnDisabledExport || (issueList.length === 0)" @click="handleExport">{{ $t("Export") }}
                    </v-btn>
                    <BlinkLedModal :btnDisabledBlinking="!selected.length || btnDisabledBlinking" :selectedLabel="selectedLabel" />
                </div>
                <div>
            <Pagination @paging="paging($event)" :pageInfoText="pageInfoText" :pageIndex="pageIndex"
              :rowPerPage="rowPerPage" :goToPageInput="goToPageInput" :totalPages="totalPages"
              @updatePage="updatePage($event)"></Pagination>
                </div>
            </v-col>
        </v-row>
        <v-dialog
            v-model="showShelfImage"
            v-if="showShelfImage"
            persistent
            :retain-focus="false"
            max-width="900"
            transition="dialog-bottom-transition"
        >
            <v-card class="d-flex flex-column zoom-dialog-card">
                <div style="height: 64px; background-color: #001E38; width: 100%; display: flex; align-items: center; padding: 0 16px;">
                    <v-btn icon dark small :disabled="shelfStatusZoom <= 0.25" @click="zoomOut" :title="$t('Zoom Out')">
                        <v-icon>mdi-magnify-minus-outline</v-icon>
                    </v-btn>
                    <span class="zoom-label">{{ Math.round(shelfStatusZoom * 100) }}%</span>
                    <v-btn icon dark small :disabled="shelfStatusZoom >= 5" @click="zoomIn" :title="$t('Zoom In')">
                        <v-icon>mdi-magnify-plus-outline</v-icon>
                    </v-btn>
                    <v-btn icon dark small @click="resetZoom" :title="$t('Reset Zoom')">
                        <v-icon>mdi-magnify-close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="handleClose">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
                <div
                    ref="imageViewport"
                    class="image-viewport"
                    @wheel.prevent="onWheel"
                    @mousedown.prevent="onMouseDown"
                    @mousemove="onMouseMove"
                    @mouseup="onMouseUp"
                    @mouseleave="onMouseUp"
                    :style="{ cursor: isDragging ? 'grabbing' : 'grab' }"
                >
                    <img
                        v-if="selectedShelfImage"
                        class="zoomable-image"
                        :src="selectedShelfImage"
                        :style="{
                            transform: `translate(${translateX}px, ${translateY}px) scale(${shelfStatusZoom})`,
                            transformOrigin: '0 0'
                        }"
                        @load="onImageLoad"
                        @dragstart.prevent
                    />
                    <div v-else class="no-image-placeholder">{{ $t('No Image Available') }}</div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Pagination from '@/components/pagination/Pagination.vue'
import BlinkLedModal from '../../components/modal/BlinkLedModal.vue'
import codes from '../../plugins/codes'
import commons from '@/plugins/commons'
import EventBus from '@/plugins/eventBus.js'
import { mapGetters } from 'vuex'
import Pagenation from '@/mixins/Pagenation'
import { exportFiles } from '@/plugins/exporter'

export default {
  components: { BlinkLedModal, Pagination },
  mixins: [Pagenation],
  name: 'ShelfTabItem',
  props: {
    value: {
      type: String,
      required: true
    },
    floorItems: {
      type: Array,
      required: true
    },
    floorMap: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      searchBy: {
        floor: null,
        section: null,
        shelfId: null,
        type: null,
        startDate: null,
        endDate: null
      },
      showShelfImage: false,
      selectedShelfImage: null,
      shelfStatusZoom: 0.5,
      translateX: 0,
      translateY: 0,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      typeItems: ['OOS', 'LOW', 'MIS'],
      showStartDatePicker: false,
      showEndDatePicker: false,
      languageCodes: {
        English: 'en',
        한국어: 'ko',
        Deutsch: 'de',
        Francais: 'fr',
        中文: 'zh',
        Espanol: 'es',
        Italiano: 'it',
        Portugal: 'por',
        日本語: 'jp'
      },
      selected: [],
      menuOpen: false,
      visibleColumns: [],
      shelfHeaders: [
        { text: this.$t('Type'), align: 'center', sortable: false, value: 'type' },
        { text: this.$t('Label ID'), align: 'center', sortable: false, value: 'labelCode' },
        { text: this.$t('Product ID'), align: 'center', sortable: false, value: 'articleId' },
        { text: this.$t('Product Name'), align: 'center', sortable: false, value: 'articleName' },
        { text: this.$t('Location'), align: 'center', sortable: false, value: 'location' },
        { text: this.$t('Status'), align: 'center', sortable: false, value: 'status' },
        { text: this.$t('Duration'), align: 'center', sortable: false, value: 'duration' },
        { text: this.$t('Starts At'), align: 'center', sortable: false, value: 'createdAt' },
        { text: this.$t('Detail'), align: 'center', sortable: false, value: 'detail' },
        { text: this.$t('Actions'), align: 'center', sortable: false, value: 'actions' }
      ],
      issueList: [],
      shelfItems: [],
      page: 1,
      rowPerPage: '10',
      pageIndex: 1,
      pageCount: 0,
      totalPages: 0,
      pageInfoText: null,
      goToPageInput: 1,
      btnDisabledDetails: null,
      btnDisabledExport: null,
      btnDisabledBlinking: null
    }
  },
  computed: {
    filteredHeaders () {
      return this.shelfHeaders.filter(
        h => h.value === 'labelCode' || h.value === 'type' || this.visibleColumns.includes(h.text)
      )
    },
    isAllSelected () {
      return this.visibleColumns.length === this.shelfHeaders.slice(2).length
    },
    selectedLabel () {
      return this.selected.map(element => element.labelCode)
    },
    ...mapGetters({
      store: 'dataStore/GET_SELECTED_STORE'
    })
  },
  watch: {
    value (newVal) {
      this.pageIndex = 1
      this.page = 1
      this.goToPageInput = 1
      this.selected = []
      this.getShelfTasks(1)
    },
    store: {
      handler () {
        if (!this.store.code) {
          EventBus.$emit('openSelectedStores')
          this.issueList = []
          this.selected = []
          this.totalPages = 0
          this.pageInfoText = null
          this.page = 1
          this.pageIndex = 1
          this.goToPageInput = 1
          this.searchBy = { floor: null, section: null, shelfId: null, type: null, startDate: null, endDate: null }
          return
        }
        this.getShelfTasks(1)
      }
    }
  },
  methods: {
    handleClose () {
      this.showShelfImage = false
    },
    centerImage (imgEl) {
      const viewport = this.$refs.imageViewport
      if (!viewport || !imgEl) return
      const vw = viewport.clientWidth
      const vh = viewport.clientHeight
      const iw = imgEl.naturalWidth
      const ih = imgEl.naturalHeight
      if (!iw || !ih) return
      const fitZoom = parseFloat(Math.min(vw / iw, vh / ih).toFixed(4))
      this.shelfStatusZoom = fitZoom
      this.translateX = (vw - iw * fitZoom) / 2
      this.translateY = (vh - ih * fitZoom) / 2
    },
    onImageLoad (e) {
      this.$nextTick(() => this.centerImage(e.target))
    },
    resetZoom () {
      const viewport = this.$refs.imageViewport
      const img = viewport ? viewport.querySelector('img') : null
      if (img && img.complete && img.naturalWidth) {
        this.centerImage(img)
      } else {
        this.shelfStatusZoom = 1
        this.translateX = 0
        this.translateY = 0
      }
    },
    zoomIn () {
      const newZoom = Math.min(5, parseFloat((this.shelfStatusZoom + 0.25).toFixed(2)))
      const viewport = this.$refs.imageViewport
      if (viewport) {
        const rect = viewport.getBoundingClientRect()
        const cx = rect.width / 2
        const cy = rect.height / 2
        const factor = newZoom / this.shelfStatusZoom
        this.translateX = cx - factor * (cx - this.translateX)
        this.translateY = cy - factor * (cy - this.translateY)
      }
      this.shelfStatusZoom = newZoom
    },
    zoomOut () {
      const newZoom = Math.max(0.25, parseFloat((this.shelfStatusZoom - 0.25).toFixed(2)))
      const viewport = this.$refs.imageViewport
      if (viewport) {
        const rect = viewport.getBoundingClientRect()
        const cx = rect.width / 2
        const cy = rect.height / 2
        const factor = newZoom / this.shelfStatusZoom
        this.translateX = cx - factor * (cx - this.translateX)
        this.translateY = cy - factor * (cy - this.translateY)
      }
      this.shelfStatusZoom = newZoom
    },
    onWheel (e) {
      const step = 0.1
      const direction = e.deltaY < 0 ? 1 : -1
      const newZoom = Math.max(0.25, Math.min(5, parseFloat((this.shelfStatusZoom + direction * step).toFixed(2))))
      if (newZoom === this.shelfStatusZoom) return
      const viewport = this.$refs.imageViewport
      const rect = viewport.getBoundingClientRect()
      const mouseX = e.clientX - rect.left
      const mouseY = e.clientY - rect.top
      const factor = newZoom / this.shelfStatusZoom
      this.translateX = mouseX - factor * (mouseX - this.translateX)
      this.translateY = mouseY - factor * (mouseY - this.translateY)
      this.shelfStatusZoom = newZoom
    },
    onMouseDown (e) {
      this.isDragging = true
      this.dragStartX = e.clientX - this.translateX
      this.dragStartY = e.clientY - this.translateY
    },
    onMouseMove (e) {
      if (!this.isDragging) return
      this.translateX = e.clientX - this.dragStartX
      this.translateY = e.clientY - this.dragStartY
    },
    onMouseUp () {
      this.isDragging = false
    },
    getPageInfoText (headers) {
      if (headers['x-totalelements'] === '0' || headers['x-totalelements'] === null || headers['x-totalelements'] === undefined) {
        return '0 to 0, 0 ' + this.$t('in total')
      }
      return (
        `${headers['x-number'] * 1 * headers['x-size'] + 1} ${this.$t('to')} ${headers['x-number'] * 1 * headers['x-size'] + headers['x-total-count'] * 1}, ${headers['x-totalelements'] * 1}` +
        ' ' +
        this.$t('in total')
      )
    },
    saveRequestConfig: function (config) {
      const requestConfig = {
        url: config.url,
        method: config.method,
        params: config.params,
        PopUpMessage: 'true'
      }
      this.requestConfig = requestConfig
    },
    getShelfTasks (page = 1) {
      const params = {
        store: this.store.code,
        page: page - 1,
        size: this.rowPerPage
      }
      if (this.value && this.value !== 'ALL') params.status = this.value
      if (this.searchBy.floor) params.floor = this.searchBy.floor
      if (this.searchBy.section) params.section = this.searchBy.section
      if (this.searchBy.shelfId) params.shelfId = this.searchBy.shelfId
      if (this.searchBy.type) params.type = this.searchBy.type
      if (this.searchBy.startDate) params.startDate = this.searchBy.startDate
      if (this.searchBy.endDate) params.endDate = this.searchBy.endDate
      const config = { params }
      this.$utils.callAxios(
        codes.requests.togetShelfTasks.method,
        codes.requests.togetShelfTasks.url,
        config
      ).then(res => {
        this.saveRequestConfig(res.config)
        this.issueList = (res.data && res.data.issueList) ? res.data.issueList : []
        this.pageInfoText = this.getPageInfoText(res.headers)
        this.totalPages = Number(res.headers['x-totalpages'] || 0)
        this.pageIndex = page
        this.goToPageInput = page
        this.selected = []
      })
    },
    paging (input) {
      this.page = input
      this.goToPageInput = input
      this.getShelfTasks(input)
    },
    updatePage (event) {
      this.rowPerPage = event.toString()
      this.paging(1)
    },
    async confirmUpdateStatus (item, status) {
      if (status === 'rejected') {
        const ok = await this.$confirm.open({
          title: 'Mark as No Issue',
          message: 'Are you sure you want to mark this issue as No Issue?'
        })
        if (ok) {
          this.handleUpdateStatus({ ...item, status: 'NO_ISSUE' })
        }
      } else if (status === 'resolved') {
        const ok = await this.$confirm.open({
          title: 'Resolve Issue',
          message: 'Are you sure you want to mark this issue as Resolved?'
        })
        if (ok) {
          this.handleUpdateStatus({ ...item, status: 'RESOLVED' })
        }
      } else if (status === 'pending') {
        const ok = await this.$confirm.open({
          title: 'Pending Issue',
          message: 'Are you sure you want to mark this issue as Pending?'
        })
        if (ok) {
          this.handleUpdateStatus({ ...item, status: 'PENDING' })
        }
      } else if (status === 'reOpen') {
        const ok = await this.$confirm.open({
          title: 'ReOpen Issue',
          message: 'Are you sure you want to reopen this issue?'
        })
        if (ok) {
          this.handleUpdateStatus({ ...item, status: 'OPEN' })
        }
      }
    },
    handleUpdateStatus (item) {
      const data = {
        ...item
      }

      const issueDate = data.issueDate.split('-')

      delete data.id
      delete data.lastModified
      delete data.createdAt
      delete data.articleName
      delete data.shelfGroup
      data.issueDate = issueDate && issueDate.length === 3 ? `${issueDate[0]}-${String(issueDate[1]).padStart(2, '0')}-${String(issueDate[2]).padStart(2, '0')}` : null
      const params = {

      }

      this.$utils.callAxiosWithBody(
        codes.requests.toUpdateShelfTask.method,
        codes.requests.toUpdateShelfTask.url,
        data,
        params
      ).then(res => {
        const result = res.data
        EventBus.$emit('messageAlert', this.$t(result.returnMsg))
        this.getShelfTasks(this.page)
      })
    },
    handleExport () {
      exportFiles(this.requestConfig, this.$refs.link, 'ShelfTaskList.xlsx')
    },
    handleSearch () {
      this.pageIndex = 1
      this.page = 1
      this.goToPageInput = 1
      this.getShelfTasks(1)
    },
    clearSearch () {
      this.searchBy = {
        floor: null,
        section: null,
        shelfId: null,
        type: null,
        startDate: null,
        endDate: null
      }
      this.handleSearch()
    },
    convertDate (time) {
      const seconds = Math.floor(time / 1000)
      const minutes = Math.floor(seconds / 60)
      const hours = Math.floor(minutes / 60)
      const days = Math.floor(hours / 24)
      const months = Math.floor(days / 30)
      const years = Math.floor(months / 12)
      if (years > 0) return years + ' years'
      if (months > 0) return months + ' months'
      if (days > 0) return days + ' days'
      if (hours > 0) return hours + ' hours'
      if (minutes > 0) return minutes + ' minutes'
      return seconds + ' seconds'
    },
    checkStartDate (val) {
      if (val > this.searchBy.endDate) {
        this.searchBy.startDate = null
        EventBus.$emit(
          'messageAlert',
          this.$t('The start date is must be prior to the end date.')
        )
      }
    },
    checkEndDate (val) {
      if (val < this.searchBy.startDate) {
        this.searchBy.endDate = null
        EventBus.$emit(
          'messageAlert',
          this.$t('The end date is must be after the start date.')
        )
      }
    },
    formatTimeStamp (timestamp) {
      return commons.convertDate(timestamp)
    },
    clearDate (searchBy, dateType) {
      searchBy[dateType] = null
    },
    toggleSelectAll (value) {
      if (value) {
        this.visibleColumns = this.shelfHeaders.slice(2).map(header => header.text)
      } else {
        this.visibleColumns = []
      }
    },
    handleDetailClick (item) {
      this.selectedShelfImage = item.image || null
      this.shelfStatusZoom = 1
      this.translateX = 0
      this.translateY = 0
      this.showShelfImage = true
    },
    handleColumnSave () {
      commons.saveCustomColumn('SHELF_TASKS', this.visibleColumns).then((res) => {
        if (res.status === 200) {
          EventBus.$emit('messageAlert', res.data.responseMessage)
          this.togetCustomColumn()
        }
      })
    },
    togetCustomColumn () {
      commons.togetCustomColumn('SHELF_TASKS').then((res) => {
        if (res && res.length > 0) {
          this.visibleColumns = res
        } else {
          this.visibleColumns = this.shelfHeaders.slice(0, 2).map(h => h.text)
        }
      })
    },
    textPicker (type) {
      switch (type) {
        case 'MIS': return this.$t('Misplaced')
        case 'OOS': return this.$t('Out of Stock')
        case 'LOW': return this.$t('Low Stock')
        default:
          return '-'
      }
    }
  },
  mounted () {
    this.$store.dispatch('auth/getDisabledBtn', '14401').then(flag => {
      this.btnDisabledDetails = flag
    })
    this.$store.dispatch('auth/getDisabledBtn', '14402').then(flag => {
      this.btnDisabledExport = flag
    })
    if (!this.store.code) {
      EventBus.$emit('openSelectedStores')
      return
    }
    this.getShelfTasks(1)
    this.togetCustomColumn()
  }
}
</script>

<style scoped>
.columnMenu {
    max-width: 260px;
    top: 250px;
}

.column-header {
  font-weight: 600;
  font-size: 14px;
  padding: 12px 16px;
}

.column-card {
    width: 100%;
    max-width: 260px;
}

.column-list {
    max-height: 260px;
    overflow-y: auto;
    padding: 0 8px;
}

.column-text {
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.column-footer {
    position: sticky;
    bottom: 0;
    background: #fff;
    padding: 8px 12px;
}

.manage-btn {
    max-width: 200px;
    white-space: nowrap;
}

.rotate {
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}

.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}

::v-deep .v-data-table thead th {
  background-color: #ececec !important;
  white-space: nowrap;
  text-transform: uppercase;
}

::v-deep ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::v-deep ::-webkit-scrollbar-track {
  background: var(--lightestgrey);
}

::v-deep ::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 5px;
}

::v-deep ::-webkit-scrollbar-thumb:hover {
  background: #c1c1c1;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 5px;
}

.zoom-dialog-card {
  height: 80vh;
}

.image-viewport {
  flex: 1;
  overflow: hidden;
  position: relative;
  user-select: none;
  -webkit-user-select: none;
    background-color: rgb(0, 30, 56, 0.9);
}

.zoomable-image {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  max-width: none;
  pointer-events: none;
}

.no-image-placeholder {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #aaa;
  font-size: 14px;
}

.zoom-label {
  color: #fff;
  font-size: 13px;
  min-width: 48px;
  text-align: center;
  display: inline-block;
}

.action-group {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
}

.actions {
  cursor: pointer;
  display: inline-flex;
}
</style>
